import {
    WidgetCustomManagedStreamOptions,
    WidgetStreamByRequestUidConfig,
    WidgetWithMarketDataRequestConfig,
} from 'widgets/streaming/widgetStreamManager/WidgetCustomStreamManager';
import { FillsGraphByOrderIdOrSymQtyStreamRequestWithSymQty } from 'communication/types/fillsGraph/FillsGraphByOrderIdOrSymQtyStreamRequest';
import {
    getFillsGraphStreamRequestBySymbolInfosForSymbols,
    getFillsGraphStreamRequestBySymbolWithStreamKey,
} from 'widgets/fillsGraph/store/streamedData/FillsGraphStreamedDataHelpers';
import { WidgetStreamByRequestUidStreamManager } from 'widgets/streaming/widgetStreamManager/WidgetStreamByRequestUidStreamManager';
import {
    getMarketDataRequests,
    getMarketDataRequestForSymbols,
} from 'widgets/perfVsIndexCapsule/marketData';

export const perfVsIndexCapsuleStreamConfig: WidgetStreamByRequestUidConfig<FillsGraphByOrderIdOrSymQtyStreamRequestWithSymQty> &
    WidgetWithMarketDataRequestConfig = {
    channelDestination: 'startFillsGraphByOrderIdOrSymQtyStream',
    managerFactory(options: WidgetCustomManagedStreamOptions) {
        return new WidgetStreamByRequestUidStreamManager(options);
    },
    getWidgetStreamRequestInfo: (state, services, id) => {
        return getFillsGraphStreamRequestBySymbolWithStreamKey(
            state,
            services,
            id
        );
    },
    getStreamRequestInfosForSymbols:
        getFillsGraphStreamRequestBySymbolInfosForSymbols,
    getMarketDataRequests,
    getMarketDataRequestForSymbols,
};
